import Practice, { PRACTICESTATES } from "../../model/practice";

export function setPracticeState(setState: React.Dispatch<React.SetStateAction<Practice>>, practiceState: PRACTICESTATES): void {
    setState((state) => ({ ...state, state: practiceState }));
}

export function setPracticeInfo(
    setState: React.Dispatch<React.SetStateAction<Practice>>, question: string, options: string[], duration: number): void {
    setState((state) => ({ ...state, question: question, options: options, duration: duration, startTime: performance.now() }));
}

export function incrementQuestionNumber(
    setState: React.Dispatch<React.SetStateAction<Practice>>): void {
    setState((state) => ({ ...state, questionNumber: state.questionNumber + 1 }));
}

export function setQuestions(
    setState: React.Dispatch<React.SetStateAction<Practice>>, questions: number) : void {
    setState((state) => ({ ...state, questions: questions }));
}

export function incrementQuestionInfo(
    setState: React.Dispatch<React.SetStateAction<Practice>>, incrementCorrect: number, timeToAnswer: number) : void {
    setState((state) => ({
        ...state,
        correctAnswers: state.correctAnswers + incrementCorrect, timeToAnswer: state.timeToAnswer + timeToAnswer,
    }));
}
